import { useMyTimeTrackingSettings } from './useMyTimeTrackingSettings';

export const useClockOutRequirements = () => {
  const { data } = useMyTimeTrackingSettings();
  const timeFramework = data?.me.workloads[0]?.timeFramework;

  return {
    requireProjectOnClockOut:
      timeFramework?.flair__Require_Project_On_Clock_Out__c ?? false,
    requireNotesOnClockOut:
      timeFramework?.flair__Require_Notes_On_Clock_Out__c ?? false,
  };
};
